/***
 * File name: errors.js
 *
 * Program Description:
 * This file contains all the pre defined errors in the system
 *
 */
const errors = {
  generic: 'There was a problem processing your request. Please try again later.',
  updateProfile: 'There was a problem updating your profile. Please try again',
  fetchProfile: 'There was a problem fetching your profile.'
}

export default errors
